import React from "react";
import Seo from "../components/Seo";

const siteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Victor Springer",
  "url": "https://victorspringer.com",
  "description": "Portfolio, CV, and software engineering blog of Victor Springer.",
};

const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": "https://victorspringer.com/#person",
  "name": "Victor Springer",
  "image": "https://victorspringer.com/avatar.jpg",
  "jobTitle": "Software Engineer (full-stack, backend-heavy)",
  "description": "Software engineer with a full-stack profile and strong backend focus, specializing in distributed systems, web applications, streaming platforms, and cloud architecture.",
  "url": "https://victorspringer.com",
  "sameAs": [
    "https://linkedin.com/in/victorspringer",
    "https://github.com/victorspringer"
  ],
  "knowsAbout": [
    "Software Engineering",
    "Go",
    "Frontend Development",
    "Web Applications",
    "Distributed Systems",
    "Streaming Platforms",
    "Software Architecture",
    "Cloud Architecture",
    "Backend Development",
    "Full-Stack Development"
  ],
  "mainEntityOfPage": "https://victorspringer.com"
};

const homePageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://victorspringer.com",
  "url": "https://victorspringer.com",
  "name": "Victor Springer | Software Engineer (Full-Stack, Backend-Heavy)",
  "description": "Personal website of Victor Springer with portfolio, CV, and articles about software engineering, architecture, backend systems, and career growth.",
  "about": {
    "@id": "https://victorspringer.com/#person"
  }
};

const Home = () => {
  return (
    <>
      <Seo
        title="Software Engineer (Full-Stack, Backend-Heavy)"
        description="Victor Springer is a software engineer in Berlin with a full-stack profile and strong backend focus across distributed systems, web applications, and cloud architecture."
        keywords={[
          "Victor Springer",
          "Software Engineer",
          "Senior Backend Engineer",
          "Full-Stack Engineer",
          "Go",
          "Golang",
          "Distributed Systems",
          "Media Streaming",
          "Cloud Architecture",
          "Berlin",
        ]}
        imageAlt="Portrait of Victor Springer"
        structuredData={[siteSchema, personSchema, homePageSchema]}
      />

      <header className="max-w-4xl mx-auto">
        <img
          src="/avatar.jpg"
          alt="Portrait of Victor Springer, software engineer in Berlin"
          width="192"
          height="192"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          className="w-48 h-48 mx-auto mb-4 rounded-full border-2 border-dracula-green"
        />
        <h1 className="text-dracula-pink text-4xl font-semibold mb-4 text-center">Hello, world!<span className="cursor"></span></h1>
      </header>

      <main className="max-w-4xl mx-auto">
        <section className="text-lg">
          <p>
            Hey, I'm <strong className="text-dracula-green">Victor</strong>! A <strong className="text-dracula-green">Software Engineer</strong> with over a decade of experience in backend and full-stack development.
            I specialize in <strong className="text-dracula-green">Golang, distributed systems, media streaming, and cloud platforms</strong>.
            Throughout my career, I've helped startups and global companies build scalable, high-performance and long-lasting systems.
            When I'm not crafting software, you'll find me traveling, playing music (I'm passionate about string instruments), or enjoying sports.
          </p>
        </section>

        <section className="text-lg mt-4">
          <p>
            This website is where I share my <strong className="text-dracula-green">professional experience</strong> and <strong className="text-dracula-green">thoughts on tech</strong>.
            Check out my <a href="/cv" className="text-dracula-purple underline">CV</a> or dive into my <a href="/blog" className="text-dracula-purple underline">Blog</a>, where I write about software engineering, career growth, and the tech industry.
          </p>
        </section>

        <section className="text-lg mt-4">
          <p>
            You can reach me <a href="/contact" className="text-dracula-purple underline" rel="noopener noreferrer">here</a> or check out my projects on <a href="https://github.com/victorspringer" className="text-dracula-purple underline" rel="noopener noreferrer">GitHub</a>.
          </p>
        </section>
      </main>
    </>
  );
};

export default Home;
